import React, { ChangeEvent, useEffect, useRef, useState } from 'react'
import { useSearchParams } from 'react-router-dom'
import WarningWorkflowProcess from '../warningWorkflowProcessComp/WarningWorkflowProcess';
import { CloseIcon, SearchIcon } from '../iconSet/IconSet';
import InputGroup from '../inputComp/InputGroup';
import { RecipientType } from '../earlyWarning/emailComp/EmailTypes';

function ExternalEW() {
    const BASE_URL = process.env.REACT_APP_BASE_URL;
    const [searchParams] = useSearchParams();
    const getToken = searchParams.get("token")

    const [warningId, setWarningId] = useState<string>('')
    const [username, setUsername] = useState<string>('')

    useEffect(() => {
    if (!getToken) return;

    console.log(">>>>>>>>>> TOKEN: ", getToken)
    fetch(`${BASE_URL}/identity_manager/api/v1/jwt-details?token=${getToken}`)
        .then(res => {
            if (!res.ok) throw new Error('Failed to fetch token details');
            return res.json();
        })
        .then(data => {
            if (data.warningId) {
                setWarningId(data.warningId);
                setUsername(data.username)
                console.log(">>>>>>>>>> Data: ", data)
            } else {
                console.warn('warningId not found in response:', data);
            }
        })
        .catch(err => {
            console.error('Error fetching token details:', err);
        });
    }, [getToken])
    
    
    return (
        <div className='accept-external-ew App colorful'>
            <div className='container' style={{backgroundColor: '#ffffffff', border: 'solid 0.1rem gray'}}>
                <WarningWorkflowProcess type='EXTERNAL' id={warningId} token={getToken!} catMType='FLW' currentUser={username}/>
            </div>
        </div>
    )
}

export default ExternalEW